/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateCardLinkRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/CreateCardLink.pb'
import {CreateCardLinkResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/CreateCardLink.pb'


export const createCardLink = (request: CreateCardLinkRequest, options?: CashRequestOptions) => post<CreateCardLinkRequest, CreateCardLinkResponse>("/2.0/cash/create-card-link", request, {...options, rejectOnError: true })